//export const API_URL = 'http://op-shop.embdev.in/rest/V1/delivery/';
export const Accept = "application/json";
export let API_URL;
//Constants Reducer And Action
if (process.env.NODE_ENV === "development") {
  // API_URL = "https://bmmimigration.embdev.in/";
  //API_URL = "https://rider.devxbmmi.com/";
  API_URL = "https://rider.bmmi-online.com/";
} else {
  //if(window.location.host==='rider.spencers.in')
  // API_URL = "https://bmmimigration.embdev.in/";
  //API_URL = "https://rider.devxbmmi.com/";
  API_URL = "https://rider.bmmi-online.com/";
  // API_URL = 'http://op-shop.embdev.in/rest/V1/delivery/';
  //  else {
  //    API_URL = 'http://op-shop.embdev.in/rest/V1/delivery/';
  //  }
}
export const LOGIN = "LOG_IN";
export const GETJOBS = "GET_JOBS";
export const GETPICKERS = "GET_PICKERS";



// WEBPACK FOOTER //
// ./src/utility/constants.js